export default __webpack_public_path__ + "static/media/acid_rain.b46002b3.svg";